<template>
  <v-app-bar app color="primary" dark dense>
    <a href="/" style="color: #ffffff; text-decoration: none" class="mr-2" color="white">Сервисный отдел ООО "Компакт-7"</a>

    <v-spacer></v-spacer>
    <a href="/order/make" style="color: #ffffff; text-decoration: none" class="mr-2" color="white">Создать заказ</a>
    <a href="/login" style="color: #ffffff; text-decoration: none" class="mr-2" color="white">Вход в личный кабинет</a>
  </v-app-bar>
</template>

<script>
export default {
  methods: {},
};
</script>